// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Divider,
    IconButton,
    Fab,
    Autocomplete,
    InputLabel,
    Select,
    MenuItem,
    Tooltip,
} from '@mui/material'
import { useNavigate, useParams } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import appInfo from '../../../../configs/app-info';
import { getCustomer, getDesigner, getProduct, getSales } from '../../../../api/helper';
import AttachmentFab from '../../../../components/attachment/AttachmentFab';
import DialogDP from '../../../../components/acc/DialogDP';
import { useToast } from '../../../../components/ToastProvider';
import FloatingJurnalButton from '../../../../components/acc/jurnal/FabJurnal';

const formatNumber = (value: string) => {
    const raw = value.replace(/[^0-9,]/g, '')
    const parts = raw.split(',')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return parts.join(',')
}

const terbilang = (nominal: number) => {
    if (isNaN(nominal) || nominal < 0) return 'Nominal tidak valid'

    const satuan = ['', 'SATU', 'DUA', 'TIGA', 'EMPAT', 'LIMA', 'ENAM', 'TUJUH', 'DELAPAN', 'SEMBILAN', 'SEPULUH', 'SEBELAS']

    const penyebut = (n: number): string => {
        if (n < 12) return satuan[n]
        if (n < 20) return `${penyebut(n - 10)} BELAS`
        if (n < 100) return `${penyebut(Math.floor(n / 10))} PULUH ${penyebut(n % 10)}`
        if (n < 200) return `SERATUS ${penyebut(n - 100)}`
        if (n < 1000) return `${penyebut(Math.floor(n / 100))} RATUS ${penyebut(n % 100)}`
        if (n < 2000) return `SERIBU ${penyebut(n - 1000)}`
        if (n < 1000000) return `${penyebut(Math.floor(n / 1000))} RIBU ${penyebut(n % 1000)}`
        if (n < 1000000000) return `${penyebut(Math.floor(n / 1000000))} JUTA ${penyebut(n % 1000000)}`
        if (n < 1000000009) return `${penyebut(Math.floor(n / 1e9))} MILIAR ${penyebut(n % 1e9)}`
        return 'Angka terlalu besar'
    }

    const result = penyebut(Math.floor(nominal))?.replace(/\s+/g, ' ').trim() || ''

    return `${result} RUPIAH`
}

export default function Detail() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const navigate = useNavigate();

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const { id } = useParams();
    const { showToast, hideToast } = useToast();

    const [isProduksi, setIsProduksi] = useState<any>(1)
    const [valCustomer, setValCustomer] = useState<any>(null)
    const [listCustomer, setListCustomer] = useState<any[]>([])

    const [valSales, setValSales] = useState<any>(null)
    const [listSales, setListSales] = useState<any[]>([])

    const [valDesigner, setValDesigner] = useState<any>(null)
    const [listDesigner, setListDesigner] = useState<any[]>([])

    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [listDetail, setListDetail] = useState<any[]>([])
    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [openProductDialog, setOpenProductDialog] = useState<boolean>(false)
    const [isEdit, setIsEdit] = useState<boolean>(false)

    const [listProduct, setListProduct] = useState<any[]>([])
    const [listSimulasi, setListSimulasi] = useState<any[]>([])
    const [openDialogSimulasi, setOpenDialogSimulasi] = useState<boolean>(false)

    const [listHistory, setListHistory] = useState<any[]>([])
    const [openDialogDP, setOpenDialogDP] = useState<boolean>(false)
    const [dialogMode, setDialogMode] = useState<string>('add')
    const [selectedData, setSelectedData] = useState<any>(null)

    useEffect(() => {
        getData()
    }, [])

    const getDoctag = (ids: any) => {
        const url = apiUrl.apiUrl + '/system/doctag/list-combo'
        axios
            .get(url, {
                params: { sysmenu_id: appInfo.menuId.salesOrder },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.id === ids) {
                            setValDoctag(element)
                            setValue('sysdoctag_id', element.id)
                        }
                    });
                    setListDoctag(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getProduct = (ids: any) => {
        const url = apiUrl.apiUrl + '/sales/quotation/list-product-new'
        axios
            .get(url, {
                params: { is_produksi: ids },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListProduct(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getHistory = () => {
        axios.get(apiUrl.apiUrl + '/sales/sales-order/get-history', {
            params: { id },
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
            if (res.data.success) {
                const data = res.data.data.map((row: any, index: any) => ({
                    dp_id: row.id,
                    ...row
                }));
                setListHistory(data)
            }
        })
    }

    const simulasiOrder = (sdso_d_id: any) => {
        const url = apiUrl.apiUrl + '/sales/quotation/detail-hitungan-order'
        axios
            .get(url, {
                params: {
                    sdso_d_id: sdso_d_id,
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListSimulasi(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const customRender = [
        {
            key: "link",
            renderCell: (row: any) =>
                row.link ? (
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                            e.stopPropagation(); // cegah rowClick
                            setOpenProductDialog(false);
                            Swal.fire({
                                title: 'Preview Gambar',
                                html: `<img src="${row.link}" alt="Gambar" style="max-width:100%;max-height:400px;" />`,
                                showCloseButton: true,
                                showConfirmButton: true,
                                confirmButtonText: 'OK',
                                width: 600,
                            }).then(result => {
                                if (result.isConfirmed) {
                                    setOpenProductDialog(true);
                                }
                            });
                        }}
                    >
                        <Icon icon="mdi:search" fontSize={20} />
                        View Image
                    </Button>
                ) : (
                    <Icon icon="mdi:close-circle-outline" fontSize={24} color="grey" />
                ),
        }
        ,
        {
            key: "id",
            renderCell: (row: any) => (
                <Typography
                    sx={{ fontWeight: 'bold', cursor: 'pointer', color: '#000' }}
                    onClick={e => {
                        e.stopPropagation();
                        window.open(`/sales/model/detail/${row.id}`, '_blank');
                    }}
                >
                    {row.link}
                </Typography>
            ),
        }
    ];

    const getDetail = () => {

        const url = apiUrl.apiUrl + '/sales/sales-order/detail-item/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    setListDetail(response.data.data)

                    getHistory()
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(error => {
                Swal.fire({
                    title: 'Pemberitahuan',
                    text: error.message,
                    icon: 'error'
                })
            })
    }

    const getData = () => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/sales/sales-order/detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setValue('syscabang_id', data.syscabang_id)
                    setValue('sysdoctag_id', data.sysdoctag_id)
                    setValue('sdcust_id', data.sdcust_id)
                    setValue('sdsalesman_id', data.sdsalesman_id)
                    setValue('nomor_po', data.nomor_po)
                    setValue('kode', data.kode)
                    setValue('tgl', data.tgl.replace(' ', 'T').substring(0, 16))
                    setValue('tgl_close', data.tgl_close.replace(' ', 'T').substring(0, 16))
                    setValue('tgl_kirim', data.tgl_kirim.replace(' ', 'T').substring(0, 16))
                    setValue('keterangan', data.keterangan)
                    setValue('total_valas_ppn', data.total_valas_ppn)
                    setValue('designer_id', data.designer_id)
                    getDoctag(data.sysdoctag_id)
                    fetchCustomer(data.sdcust_id);
                    fetchSales(data.sdsalesman_id);
                    fetchDesigner(data.designer_id)

                    getDetail()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getDetailDP = (id: any) => {

        let url = apiUrl.apiUrl + '/acc/dp-customer/detail/' + id

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0]

                    setDialogMode('edit')
                    setSelectedData(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const fetchDesigner = async (designerId: any) => {
        const response = await getDesigner(cabang, token);
        response.forEach((element: { id: any; }) => {
            if (element.id === designerId) {
                setValDesigner(element)
                setValue('designer_id', element.id)
            }
        });
        setListDesigner(response);
    };

    const handleChangeAutocompleteDesigner = (event: SyntheticEvent, newValue: any | null) => {
        setValue('designer_id', newValue ? newValue.id : null)
        setValDesigner(newValue)
    }

    const handleChangeAutocompleteSales = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sdsalesman_id', newValue ? newValue.id : null)
        setValSales(newValue)
    }
    const handleChangeAutocompleteCustomer = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sdcust_id', newValue ? newValue.id : null)
        setValCustomer(newValue)
    }

    const resetDetail = () => {
        setValue('sdproduct_id', null)
        setValue('product', '')
        setValue('qty', null)
        setValue('keterangan_detail', null)
        setValue('sdso_d_id', null)
    }

    interface FormInputs {
        syscabang_id: any,
        sysdoctag_id: any,
        sdcust_id: any,
        sdsalesman_id: any,
        nomor_po: any,
        kode: any
        tgl: any,
        tgl_close: any,
        tgl_kirim: any,
        keterangan: any,
        sdproduct_id: any,
        qty: any,
        keterangan_detail: any,
        product: any,
        sdso_d_id: any,
        harga: any,
        total_valas_ppn: any,
        designer_id: any,
    }

    const defaultValues = {
        syscabang_id: cabang,
        sdproduct_id: null,
        product: ''
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue?.id)
        setValDoctag(newValue)
    }


    const fetchCustomer = async (sdcust_id: any) => {
        const response = await getCustomer(token);
        response.forEach((element: { id: any; }) => {
            if (element.id === sdcust_id) {
                setValCustomer(element)
                setValue('sdcust_id', element.id)
            }
        });
        setListCustomer(response);
    };
    const fetchSales = async (sdsalesman_id: any) => {
        const response = await getSales(token);
        response.forEach((element: { id: any; }) => {
            if (element.id === sdsalesman_id) {
                setValSales(element)
                setValue('sdsalesman_id', element.id)
            }
        });
        setListSales(response);
    };

    const rowClickProduct = (e: any) => {
        const data = e.data
        setValue('sdproduct_id', data?.id)
        setValue('product', data?.nama_product)
        setIsProduksi(data?.is_produksi)
        setOpenProductDialog(false)
    }

    const onSubmit = (data: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/sales/sales-order/edit/' + id
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    window.location.reload();
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    const ActionButtons = ({ row, onDelete }: {
        row: any;
        onDelete: (row: any) => void;
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:pencil",
                color: "primary",
                onClick: () => {
                    setIsEdit(true);
                    resetDetail();
                    setOpenDialog(true);
                    setValue('sdso_d_id', row.id);
                    setValue('sdproduct_id', row.sdproduct_id);
                    setValue('product', row.nama);
                    const input = row.harga;
                    const angka = Number(
                        input
                            .replace(/[^0-9,]/g, "") // sisakan angka dan koma
                            .replace(/\./g, "")      // hapus titik
                            .replace(",", ".")       // ubah koma ke titik desimal
                    );
                    setValue('harga', angka);
                    setValue('qty', row.qty);
                    setValue('keterangan_detail', row.keterangan);
                    setIsProduksi(row.is_produksi)
                }
            },
            {
                title: "Detail Order Harga",
                icon: "mdi:calculator",
                color: "primary",
                onClick: () => {
                    simulasiOrder(row.id);
                    setOpenDialogSimulasi(true);
                }
            },
            {
                title: "Hapus Sales Order",
                icon: "mdi:trash",
                color: "primary",
                onClick: () => onDelete(row)
            }
        ];

        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const handleDelete = (row: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda yakin ingin menghapus item ini?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Hapus'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })
                axios
                    .delete(`${apiUrl.apiUrl}/sales/quotation/delete-item/${row.id}`, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        Swal.close()
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true
                            })
                            getData()
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.close()
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 200,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                />
            ),
        },
    ];


    const tambahItem = () => {
        setOpenDialog(false)
        let msg = "";
        const sdproduct_id = getValues('sdproduct_id');
        const qty = getValues('qty');
        if (!sdproduct_id) {
            msg += "Product harus diisi<br/>";
        }
        if (!qty || qty <= 0) {
            msg += "Qty harus diisi dan lebih dari 0<br/>";
        }

        if (msg != "") {
            Swal.fire({
                title: 'Pemberitahuan',
                html: msg,
                icon: 'warning'
            }).then(() => {
                setOpenDialog(true);
            });
            return;
        }
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const data = {
            sdso_id: id,
            sdproduct_id: getValues('sdproduct_id'),
            qty: getValues('qty'),
            harga: getValues('harga'),
            keterangan: getValues('keterangan_detail'),
            is_produksi: isProduksi
        }

        let url = '';
        if (isEdit) {
            url = apiUrl.apiUrl + '/sales/quotation/update-item/' + getValues('sdso_d_id')
        } else {
            url = apiUrl.apiUrl + '/sales/quotation/add-item'
        }

        axios
            .post(url, data, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'success',
                        timer: 1000,
                        timerProgressBar: true,
                        willClose: () => {
                            getData()
                        }
                    })
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(error => {
                Swal.fire({
                    title: 'Pemberitahuan',
                    text: error.message,
                    icon: 'error'
                })
            })
    }

    const convertComponent = [
        {
            key: "qty",
            renderCell: (row: any) => (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <span>{row.data.qty}</span>
                </Box>
            )
        },
        {
            key: "harga",
            renderCell: (row: any) => (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <span>{row.data.harga}</span>
                </Box>
            )
        }
    ];

    const convertComponentDP = [
        {
            key: 'dp_id',
            minWidth: 160,
            renderCell: ({ row }: any) => {
                return (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        {row.data.dp_id == null ? (
                            <Button
                                variant="contained"
                                color="warning"
                                startIcon={<Icon icon="mdi:file-document-plus" />}
                                onClick={() => {
                                    setDialogMode('add-from-list')
                                    setSelectedData(row.data)
                                    setOpenDialogDP(true)
                                }}
                            >
                                Buat DP
                            </Button>
                        ) : (
                            <>
                                <Button
                                    variant="contained"
                                    color="success"
                                    startIcon={<Icon icon="mdi:eye" />}
                                    onClick={() => {
                                        setOpenDialogDP(true)
                                        getDetailDP(row.data.dp_id)
                                    }}
                                >
                                    Lihat DP <br />
                                    {row.data.dp_id}
                                </Button>
                            </>
                        )}
                    </Box>
                )
            }
        }
    ];

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => navigate('/sales/sales-order')}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Detail Sales Order
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <br />
                    <Divider sx={{ m: 0, mb: 3 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valDoctag}
                                        options={listDoctag}
                                        id='doctag'
                                        disabled
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteDoctag}
                                        getOptionLabel={(option: any) => option.nama || ''}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Document'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valSales}
                                        options={listSales}
                                        id='sales'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteSales}
                                        getOptionLabel={(option: any) => option?.nama || ""}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label='Sales'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={1}>
                                <Fab color='primary' size='medium' onClick={() => {
                                    window.open('/sales/master-salesman/add', '_blank')
                                }}
                                >
                                    <Icon icon='mdi:plus' fontSize={35} color='white' />
                                </Fab>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valCustomer}
                                        options={listCustomer}
                                        id='customer'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteCustomer}
                                        getOptionLabel={(option: any) => option?.nama || ""}   // 👈 penting
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label='Customer'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={1}>
                                <Fab color='primary' size='medium' onClick={() => {
                                    window.open('/sales/master-customer/add', '_blank')
                                }}
                                >
                                    <Icon icon='mdi:plus' fontSize={35} color='white' />
                                </Fab>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valDesigner}
                                        options={listDesigner}
                                        id='designer_id'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteDesigner}
                                        getOptionLabel={(option: any) => option?.nama || ""}   // 👈 penting
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Designer'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='kode'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Kode Preview'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.kode)}
                                            />
                                        )}
                                    />
                                    {errors.kode && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Nomor PO harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='datetime-local'
                                                value={value}
                                                label='Tanggal'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.tgl)}
                                            />
                                        )}
                                    />
                                    {errors.tgl && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Tanggal harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl_close'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='datetime-local'
                                                value={value}
                                                label='Tanggal Close'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.tgl_close)}
                                            />
                                        )}
                                    />
                                    {errors.tgl_close && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Tanggal Close harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl_kirim'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='datetime-local'
                                                value={value}
                                                label='Rencana Kirim'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.tgl_kirim)}
                                            />
                                        )}
                                    />
                                    {errors.tgl_kirim && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Tanggal Kirim harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                onChange={onChange}
                                                multiline
                                                InputLabelProps={{ shrink: true }}
                                                rows={4}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4, mb: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                    <Box
                        sx={{
                            mt: 1,
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "flex-start",
                                mb: 1
                            }}
                        >
                            <Typography fontWeight="bold" fontSize={25}>
                                Grand Total : &nbsp;
                            </Typography>

                            <Typography fontWeight="bold" fontSize={25}>
                                Rp. {Number(getValues('total_valas_ppn') || 0).toLocaleString('id-ID')}
                            </Typography>
                        </Box>

                        {/* Terbilang */}
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "flex-start",
                                mb: 1
                            }}
                        >
                            <Typography fontWeight="bold" fontSize={25}>
                                Terbilang : &nbsp;
                            </Typography>

                            <Typography
                                fontWeight="bold"
                                fontSize={25}
                            >
                                {terbilang(getValues('total_valas_ppn') ? getValues('total_valas_ppn') : 0)}
                            </Typography>
                        </Box>
                    </Box>
                    <Divider sx={{ m: 0 }} />
                    <Box sx={{ mt: 4 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                            <Button variant="contained" color="primary"
                                sx={{ mr: 1 }}
                                onClick={() => {
                                    resetDetail()
                                    setOpenDialog(true);
                                    setIsEdit(false);
                                    setIsProduksi(0)
                                }}>
                                Tambah Product Jasa
                            </Button>
                            <Button variant="contained" color="primary"
                                onClick={() => {
                                    resetDetail()
                                    setIsEdit(false);
                                    setOpenDialog(true);
                                    setIsProduksi(1)
                                }}>
                                Tambah Product
                            </Button>
                        </Box>
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            LIST PRODUCT
                        </Typography>
                        <Box sx={{ overflowX: 'auto' }}>
                            <MsiDatagrid key={1} array={listDetail} customRender={convertComponent} actions={actionData} hiddenColumns={['id', 'sdproduct_id', 'is_produksi']} />
                        </Box>
                        <Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
                            HISTORY
                        </Typography>
                        <Button
                            variant="contained"
                            color="warning"
                            startIcon={<Icon icon="mdi:file-document-plus" />}
                            onClick={() => {
                                setDialogMode('add-from-list')
                                setSelectedData(listHistory.length > 0 ? listHistory[0] : selectedData)
                                setOpenDialogDP(true)
                            }}
                        >
                            Tambah DP
                        </Button>
                        <Box sx={{ overflowX: 'auto' }}>
                            <MsiDatagrid key={1} array={listHistory} customRender={convertComponentDP} hiddenColumns={['id', 'default_dp', 'default_dp_pesan']} />
                        </Box>
                    </Box>
                </div>
            </Grid>
            <Dialog
                maxWidth={'md'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        Tambah Product {isProduksi === 1 ? '' : 'Jasa'}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 2 }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={10} sm={10}>
                            <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                Product
                            </Typography>
                            <FormControl fullWidth>
                                <Controller
                                    name='product'
                                    control={control}
                                    render={({ field: { value } }) => (
                                        <TextField
                                            label='Product'
                                            value={value}
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={1} sm={1} sx={{ display: 'flex', alignItems: 'center', mt: 4 }}>
                            <Fab color='info' size='medium' onClick={() => {
                                setOpenProductDialog(true);
                                getProduct(isProduksi)
                            }}
                            >
                                <Icon icon='mdi:search' fontSize={35} color='white' />
                            </Fab>
                        </Grid>
                        <Grid item xs={12} md={1} sm={1} sx={{ display: 'flex', alignItems: 'center', mt: 4 }}>
                            <Fab color='primary' size='medium' onClick={() => {
                                window.open(`/sales/product/add?is_produksi=${isProduksi}`, '_blank')
                            }}
                            >
                                <Icon icon='mdi:plus' fontSize={35} color='white' />
                            </Fab>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControl fullWidth>
                                <Controller
                                    name='qty'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            label='Qty'
                                            error={Boolean(errors.qty)}
                                            onChange={onChange}
                                            value={value}
                                            type='number'
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )}
                                />
                                {errors.qty && (
                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                )}
                            </FormControl>
                        </Grid>
                        {isEdit ?
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name="harga"
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => {

                                            // Fungsi format angka → 169226 → 169.226
                                            const formatNumber = (num: any) => {
                                                if (!num) return "";
                                                return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                            };

                                            // handle input
                                            const handleChange = (e: any) => {
                                                // ambil hanya angka
                                                const raw = e.target.value.replace(/\D/g, "");

                                                // kirim value murni ke react-hook-form
                                                onChange(raw);

                                                // tampilkan yang sudah diformat
                                            };

                                            return (
                                                <TextField
                                                    label="Harga"
                                                    error={Boolean(errors.harga)}
                                                    value={formatNumber(value)}
                                                    onChange={handleChange}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            );
                                        }}
                                    />
                                    {errors.harga && (
                                        <FormHelperText sx={{ color: "error.main" }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            : null}
                        <Grid item xs={12} md={12}>
                            <FormControl fullWidth>
                                <Controller
                                    name='keterangan_detail'
                                    control={control}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}
                                            label='Keterangan'
                                            onChange={onChange}
                                            multiline
                                            InputLabelProps={{ shrink: true }}
                                            rows={4}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button variant="contained" color="primary" onClick={() => tambahItem()}>Simpan</Button>
                    <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                maxWidth={'xl'}
                fullWidth={true}
                open={openProductDialog}
                onClose={() => setOpenProductDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        List Product {isProduksi === 1 ? '' : 'Jasa'}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 4 }}>
                    <Grid container spacing={4}>
                        <MsiDatagrid array={listProduct} rowClick={rowClickProduct} customRender={customRender} hiddenColumns={['is_produksi']} />
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenProductDialog(false)}>Batal</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                maxWidth={'lg'}
                fullWidth={true}
                open={openDialogSimulasi}
                onClose={() => setOpenDialogSimulasi(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        DETAIL ORDER
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 2 }}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={12}>
                            <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1, color: '#212121' }}>
                                DETAIL HASIL ORDER
                            </Typography>
                            <MsiDatagrid array={listSimulasi} />
                            {listSimulasi.length > 0 && (
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, color: '#212121' }}>
                                    <Box sx={{ minWidth: 300 }}>
                                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
                                            Summary
                                        </Typography>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                            <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                                                Total Jual:
                                            </Typography>
                                            <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                                                {Number(listSimulasi[0]?.total_jual || 0).toLocaleString('id-ID', {
                                                    style: 'currency',
                                                    currency: 'IDR',
                                                    maximumFractionDigits: 0
                                                })}
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                            <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                                                Total Perolehan:
                                            </Typography>
                                            <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                                                {Number(listSimulasi[0]?.total_perolehan || 0).toLocaleString('id-ID', {
                                                    style: 'currency',
                                                    currency: 'IDR',
                                                    maximumFractionDigits: 0
                                                })}
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                                                Total Min:
                                            </Typography>
                                            <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                                                {Number(listSimulasi[0]?.total_min || 0).toLocaleString('id-ID', {
                                                    style: 'currency',
                                                    currency: 'IDR',
                                                    maximumFractionDigits: 0
                                                })}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            )}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialogSimulasi(false)}>Batal</Button>
                </DialogActions>
            </Dialog>

            <DialogDP
                key={selectedData?.id ?? 'add-from-list'}
                open={openDialogDP}
                mode={dialogMode}
                data={selectedData}
                doc_type={'sdso'}
                doc_id={id}
                onClose={() => {
                    setOpenDialogDP(false)
                    getDetailDP(id)
                    getData()
                }}
            />

            <FloatingJurnalButton
                id={Number(id)}
                tabel="sdso"
            />

            <AttachmentFab
                docId={Number(id)}
                docType="sdso"
            />
        </Grid >
    )
}
